module.exports = __webpack_public_path__ + "img/ipl-team.ed42b6ea.jpg";